/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderTemplate/SpiderInputInterpreter',[
		'lodash',
		'absolute/debug',
		'Arkadium/GameEngine/Core/EngineManagers',
		'SolitaireShared/CardLogic/CardAction',
		'SolitaireShared/CardLogic/CardValue',
		'SolitaireShared/CardLogic/CardSuit',
		'CardUI/CardView',
		'SolitaireShared/CardLogic/Pile'],
	function (_, Debug, EngineManagers, CardAction, CardValue, CardSuit, CardView, Pile) {
		"use strict";

		var SpiderInputInterpreter = function (authority) {
			this.initSpiderInputInterpreter(authority);
		};

		SpiderInputInterpreter.prototype.initSpiderInputInterpreter = function (authority) {
			this.Authority = authority;
			this.InputEnabled = true;
			this.IsClickedOnCard = false;
			this.tableauWasCompletedHack = false;
			this.HighlightedCard = null;
			this.HighlightTime = -1;
		};

		SpiderInputInterpreter.prototype.NotifyCardsMoved = function () {
			this.ClearHighlight();
		};


		SpiderInputInterpreter.prototype.Drag = function (cardDragged, distance) {
			if (this.IsCardHighlighted() && distance > 50) {
				this.ClearHighlight();
			}
			return true;
		};

		var DealStock = [
			"move", "Stock", "Tableau0", "1",
			"move", "Stock", "Tableau1", "1",
			"move", "Stock", "Tableau2", "1",
			"move", "Stock", "Tableau3", "1",
			"move", "Stock", "Tableau4", "1",
			"move", "Stock", "Tableau5", "1",
			"move", "Stock", "Tableau6", "1",
			"move", "Stock", "Tableau7", "1",
			"move", "Stock", "Tableau8", "1",
			"move", "Stock", "Tableau9", "1"
		];

		/// <summary>
		/// Build an action to deal out a new set of cards. Return true if action was built.
		/// </summary>
		SpiderInputInterpreter.prototype.DoDeal = function (completedPiles, completedPileFacedowns, supply, /* ref CardAction */ action) {
			var count = 0;
			if (completedPiles != null)
				count += completedPiles.length;
			if (completedPileFacedowns != null)
				count += completedPileFacedowns.length;

			var actionStrings = [];
			actionStrings[0] = "begin";
			for (var i = 0; i < DealStock.length; i++) {
				actionStrings[i + 1] = DealStock[i];
			}
			var foundationNum = 0;
			var current = DealStock.length + 1;
			if (completedPiles != null) {
				_.forEach(completedPiles, function (pile) {
					var foundation = this.GetEmptyFoundation(supply, foundationNum++);
					actionStrings[current++] = "move";
					actionStrings[current++] = pile.Name;
					actionStrings[current++] = foundation.Name;
					actionStrings[current++] = "-13";
				}, this);
			}
			if (completedPileFacedowns != null) {
				_.forEach(completedPileFacedowns, function (pile) {
					var faceDown = this.Authority.FaceDownForTableau(pile);
					actionStrings[current++] = "move";
					actionStrings[current++] = faceDown.Name;
					actionStrings[current++] = pile.Name;
					actionStrings[current++] = "1";
				}, this);
			}
			actionStrings[current] = "end";

			if (action.Parse(actionStrings) >= 0) {
				this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs()*/);
				return true;
			} else
				return false;
		};

		SpiderInputInterpreter.prototype.GetEmptyFoundation = function (supply, numberAfterFirst) {
			numberAfterFirst = numberAfterFirst || 0;
			var i = numberAfterFirst + 1;
			if (supply.GetPile("Foundation0").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation0");

			if (supply.GetPile("Foundation1").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation1");

			if (supply.GetPile("Foundation2").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation2");

			if (supply.GetPile("Foundation3").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation3");

			if (supply.GetPile("Foundation4").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation4");

			if (supply.GetPile("Foundation5").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation5");

			if (supply.GetPile("Foundation6").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation6");

			if (supply.GetPile("Foundation7").Empty) i--;
			if (i == 0) return supply.GetPile("Foundation7");

			return null;
		};


		/// <summary>
		/// Build an action to move a card from one pile to another. Return true if action was built.
		/// </summary>
		SpiderInputInterpreter.prototype.DoMoveCard = function (card, fromPile, toPile, /* ref CardAction */ action) {
			var count = fromPile.GetCardPosFromEnd(card);

			if (fromPile.Type == "Tableau") {
				var faceDownPile = this.Authority.FaceDownForTableau(fromPile);
				if (faceDownPile != null && faceDownPile.Count > 0 && fromPile.Count == count) {

					if (this.Authority.WouldCompleteRun(fromPile, toPile, count)) {
						var foundation = this.GetEmptyFoundation(fromPile.Supply);
						if (foundation == null) return false;

						var faceDownPile2 = this.Authority.FaceDownForTableau(toPile);
						if (faceDownPile2 == null) return false;

						if (faceDownPile2.Count > 0 && toPile.Count + count == 13) {
							action.Parse(["begin",
								"move", fromPile.Name, toPile.Name, count.toString(),
								"move", faceDownPile.Name, fromPile.Name, "1",
								"move", toPile.Name, foundation.Name, "-13",
								"move", faceDownPile2.Name, toPile.Name, "1",
								"end"]);
							this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);
						} else {

							action.Parse(["begin",
								"move", fromPile.Name, toPile.Name, count.toString(),
								"move", faceDownPile.Name, fromPile.Name, "1",
								"move", toPile.Name, foundation.Name, "-13",
								"end"]);
							this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);
						}

						this.tableauWasCompletedHack = true;
					} else {
						action.Parse(["begin",
							"move", fromPile.Name, toPile.Name, count.toString(),
							"move", faceDownPile.Name, fromPile.Name, "1",
							"end"]);
						this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);
					}
				} else {
					if (this.Authority.WouldCompleteRun(fromPile, toPile, count)) {
						var foundation = this.GetEmptyFoundation(fromPile.Supply);
						if (foundation == null) return false;

						var faceDownPile2 = this.Authority.FaceDownForTableau(toPile);
						if (faceDownPile2 == null) return false;

						if (faceDownPile2.Count > 0 && toPile.Count + count == 13) {
							action.Parse(["begin",
								"move", fromPile.Name, toPile.Name, count.toString(),
								"move", toPile.Name, foundation.Name, "-13",
								"move", faceDownPile2.Name, toPile.Name, "1",
								"end"]);
							this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);
						} else {
							action.Parse(["begin",
								"move", fromPile.Name, toPile.Name, count.toString(),
								"move", toPile.Name, foundation.Name, "-13",
								"end"]);
						}

						this.tableauWasCompletedHack = true;
					} else {
						action.Parse(["move", fromPile.Name, toPile.Name, count.toString()]);
					}
				}
			} else {
				return false;
			}
			return true;
		};


		SpiderInputInterpreter.prototype.Drop = function (cardDropped, dropPiles) {
			//#if WIN8
			var soundHasBeenPlayed = false;
			//#endif
			var supply = cardDropped.Card.Supply;
			var action = new CardAction(supply);
			action.Parse(["noop"]);

			if (!this.InputEnabled) return action;

			for (var i = 0; i < dropPiles.length; i++) {
				var dropPile = dropPiles[i];

				var card = cardDropped.Card;
				var fromPile = card.Pile;
				var toPile = (dropPile instanceof Pile) ? dropPile : dropPile.Pile;

				if (fromPile != toPile) {
					// if we dropped the card to a new pile, clear its highlight.
					// otherwise let it stay highlighted
					this.ClearHighlight();

					this.DoMoveCard(card, fromPile, toPile, action);

					if (action.IsAllowed()) {
						//#if WIN8
						if (this.tableauWasCompletedHack) {
							// Fixes Spider-specific bug where dropping a stack to complete a run fails to toggle off
							// IsPickedUp due to the reordering of the run from K->A to A->K on the foundation.
							if (cardDropped.Parent != null) {
								_.forEach(cardDropped.Parent.children, function (child) {
									if (child instanceof CardView)
										child.IsPickedUp = false;
								});
							}

							EngineManagers.Sounds.PlaySound("completeStack");
							soundHasBeenPlayed = true;

							this.tableauWasCompletedHack = false;
						} else {
							EngineManagers.Sounds.PlaySound("legalMove");
							soundHasBeenPlayed = true;
						}
						//#endif
						break;
					}
				} else {
					break;
				}
			}

//#if WIN8
			if (!soundHasBeenPlayed) {
				EngineManagers.Sounds.PlaySound("illegalMove");
			}
//#endif

			return action;
		};


		var Tableaus = ["Tableau0", "Tableau1", "Tableau2", "Tableau3", "Tableau4", "Tableau5", "Tableau6", "Tableau7", "Tableau8", "Tableau9"];
		SpiderInputInterpreter.prototype.ClickCard = function (cardClicked, rightClicked) {
			var supply = cardClicked.Card.Supply;

			var action = new CardAction(supply);
			action.Parse(["noop"]);
			if (rightClicked) {
				// do nothing on a right click
				return action;
			}

			if (!this.InputEnabled || (!cardClicked.IsDraggable && cardClicked.Card.Pile.Type != "Stock")) return action;

			if (cardClicked.Card.Pile.Type == "Stock")
				this.ClearHighlight();

			if (this.IsCardHighlighted()) {
				var card = this.HighlightedCard.Card;
				var fromPile = card.Pile;
				var toPile = cardClicked.Card.Pile;

				if (fromPile != toPile) {
					this.DoMoveCard(card, fromPile, toPile, action);

					if (action.IsAllowed()) {
						this.ClearHighlight();

						// Make the player release mouse button and click again to drag the destination card
						// because immediate dragging after a click move causes shadow and layering bugs.
						cardClicked.IsDragging = cardClicked.SupplyView.IsCardDragging = false;
					} else {
						if (this.Authority.CanPickupCard(cardClicked.Card)) this.HighlightCard(cardClicked);
					}
				} else if (this.Authority.CanPickupCard(cardClicked.Card)) {
					// Select a different card in the same pile.
					this.HighlightCard(cardClicked);
				} else {
					this.Authority.TriggerTip(/* TODO new TipEventArgs("Tips_Spider_MoveCards") */);
				}

//#if WIN8
				if (action.IsAllowed()) {
					EngineManagers.Sounds.PlaySound("legalMove");
				}
//#endif
			} else {
				var pile = cardClicked.Card.Pile;
				if (pile.Name == "Stock") {
					var completedPiles = null;
					var completedPileFacedowns = null;
					if (pile.Count >= 10) {
						for (var i = 0; i < 10; i++) {
							var dealtCard = pile.NthFromTop(i + 1);
							if (dealtCard.Value == CardValue.Values.Ace) {
								// if it's an ace, check the pile it's going to
								var dealtTo = supply.GetPile(Tableaus[i]);
								if (dealtTo != null && !dealtTo.Empty &&
									dealtTo.Top.Value == CardValue.Values.Two &&
									dealtTo.Top.Suit == dealtCard.Suit &&
									this.Authority.SuitedRunLength(dealtTo) == 12) {
									if (completedPiles == null) completedPiles = [];
									completedPiles.push(dealtTo);
								}
							}
						}
						if (completedPiles != null) {
							_.forEach(completedPiles, function (compPile) {
								var compFacedown = this.Authority.FaceDownForTableau(compPile);

								if (compFacedown != null &&
									compPile.Count == 12 &&
									!compFacedown.Empty) {
									if (completedPileFacedowns == null) completedPileFacedowns = [];
									completedPileFacedowns.push(compPile);
								}
							}, this);
						}
					}
					this.DoDeal(completedPiles, completedPileFacedowns, supply, action);
//#if WIN8
					if (action.IsAllowed()) {
						cardClicked.Parent.FanLimit--;
					} else {
						if (!this.Authority.IsDealAllowed()) {
							var pileTopCard = cardClicked.SupplyView.GetCardView(cardClicked.Card.Pile.Top);
							pileTopCard.AnimateSingleTapRejection();
							EngineManagers.Sounds.PlaySound("illegalMove");
						}
						action.isAllowed = false;
						return action;
					}
//#endif

					this.ClearHighlight();
				} else {
					if (this.Authority.CanPickupCard(cardClicked.Card)) {
						this.HighlightCard(cardClicked);
					} else {
						this.Authority.TriggerTip(/* TODO new TipEventArgs("Tips_Spider_MoveCards") */);
					}
				}
			}

			if (action.IsAllowed() && this.tableauWasCompletedHack) {
//          #if WIN8
				EngineManagers.Sounds.PlaySound("foundation");
//          #endif
				this.tableauWasCompletedHack = false;
			}

			return action;
		};


		SpiderInputInterpreter.prototype.ClickEmptyPile = function (pileClicked) {
			var supply = pileClicked.Pile.Supply;
			var action = new CardAction(supply);
			action.Parse(["noop"]);

			if (!this.InputEnabled) return action;

			if (this.IsCardHighlighted()) {
				var card = this.HighlightedCard.Card;
				var fromPile = card.Pile;
				var toPile = pileClicked.Pile;
				this.DoMoveCard(card, fromPile, toPile, action);
				this.ClearHighlight();
			} else {

				// nothing to do if we click an empty pile without a card highlighted
			}
			return action;
		};

		SpiderInputInterpreter.prototype.ClickOutside = function () {
			// Clear the selected card
			this.ClearHighlight();
		};

		SpiderInputInterpreter.prototype.IsCardHighlighted = function () {
			return (this.HighlightedCard != null);
		};

		SpiderInputInterpreter.prototype.GetHighlightedCard = function () {
			return this.HighlightedCard;
		};

		SpiderInputInterpreter.prototype.HighlightCard = function (card) {
			this.HighlightedCard = card;
			this.HighlightedCard.Highlight();
			this.HighlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
			Debug.log("HighlightCard " + card.Card.ToString());
			// notify UI?
		};

		SpiderInputInterpreter.prototype.ClearHighlight = function () {
			if (this.HighlightedCard != null) {
				this.HighlightedCard.ClearHighlight();
				this.HighlightedCard = null;
				this.HighlightTime = -1;
			}
			Debug.log("ClearHighlight()");
			// notify UI?
		};

		SpiderInputInterpreter.prototype.ShouldMoveKeyboard = function (action, card) {
			return false;
		};

		SpiderInputInterpreter.prototype.DealNextFromStock = function (supplyView) {
			var cardSupply = this.Authority.CardSupply;
			var dealAction = [
				"begin",
				"move", "Stock", "Tableau0", "1",
				"move", "Stock", "Tableau1", "1",
				"move", "Stock", "Tableau2", "1",
				"move", "Stock", "Tableau3", "1",
				"move", "Stock", "Tableau4", "1",
				"move", "Stock", "Tableau5", "1",
				"move", "Stock", "Tableau6", "1",
				"move", "Stock", "Tableau7", "1",
				"move", "Stock", "Tableau8", "1",
				"move", "Stock", "Tableau9", "1",
				"end"
			];

			var action = new CardAction(cardSupply);
			if (!cardSupply.GetPile("Stock").Empty) {
				for (var i = 0; i < 10; i++) {
					if(cardSupply.GetPile("Tableau" + i).Empty) {
						supplyView.dealIsNotAllowed();
						var pileTopCard = supplyView.GetCardView(cardSupply.GetPile("Stock").Top);
						pileTopCard.AnimateSingleTapRejection();
					}
				}
						action.Parse(dealAction);
			}
			if (action.Run()) {
				EngineManagers.Sounds.PlaySound("Deal_Spider_Draw");
			}
		};

		return SpiderInputInterpreter;
	});

